import { Polyglot } from 'components/translate';
import { action, extendObservable } from 'mobx';
import { UiService } from 'modules/ui';

import Store from './SeasonStore';

import Request from '@hotmart/request';

const DEFAULT_OBJECT = {};

/**
 * @class
 * This class manages all operations related to Seasons, including
 * API requests and store management.
 * All required data (including dependency on data from other services) and its
 * own core data fetching should be dealt with in the `init` method.
 */
class SeasonService {
  wasInitialized = false;

  @action
  async init() {
    if (this.wasInitialized) {
      return;
    }

    if (!Store.loaded) {
      await this.fetchAllSeasons();
    }

    this.wasInitialized = true;
  }

  @action
  clear() {
    extendObservable(Store, {
      loaded: false,
      seasonList: [],
      selectedSeason: 0
    });
  }

  @action
  setData(seasonList = {}) {
    this.clear();
    extendObservable(Store, { seasonList, loaded: true, selectedSeason: 0 });
  }

  getSeasonByIndex(index) {
    return Store.seasonList[index];
  }

  getSelectedSeasonInfo() {
    return Store.seasonList[Store.selectedSeason] || DEFAULT_OBJECT;
  }

  set selectedSeason(id) {
    Store.selectedSeason = id;
  }

  get selectedSeason() {
    return Store.selectedSeason;
  }

  formatSeason(seasonList = []) {
    seasonList.map((item) => {
      if (
        item.name.includes('academy_season') ||
        item.name.includes('trooper_school')
      ) {
        item.name = Polyglot.t(item.name);
      }
      return item;
    });
    return seasonList;
  }

  @action
  async fetchAllSeasons() {
    try {
      const seasonListUnformatted = await Request('seasons.getAll');
      const seasonList = this.formatSeason(seasonListUnformatted);

      this.setData(seasonList);
      return seasonList;
    } catch (error) {
      this.handleError(error);
    }
  }

  handleError() {
    UiService.setAlertError('error');
  }
}

export default new SeasonService();
